import React from 'react';
import { Link } from 'react-router-dom';

function Landing() {
  return (
    <div className="landing fade-in">
      <h1 className="landing-title">
        The Navigational <span>Mind</span>
      </h1>
      <p className="landing-subtitle">
        Learn to navigate uncertainty with direction, articulation, and coherence
      </p>
      
      <div className="landing-intro">
        <p>
          You were born into a world without a map. Not because someone forgot to give you one—
          but because no such map exists. This course teaches you how to navigate anyway.
        </p>
      </div>

      <div className="track-cards">
        <Link to="/learner" className="track-card">
          <h3>Learner Track</h3>
          <p>
            An 8-week journey through the Navigational Mind Framework. 
            Learn the architecture of your mind, the tools of directional identity, 
            and the process of moving through uncertainty.
          </p>
          <span className="duration">8 weeks • Self-paced modules • AI Tutor available</span>
        </Link>

        <Link to="/practitioner" className="track-card">
          <h3>Practitioner Track</h3>
          <p>
            For those who want to guide others. An AI-facilitated deep dive into 
            the theoretical foundations and practical applications of the framework.
          </p>
          <span className="duration">8 weeks • AI-guided curriculum • Advanced theory</span>
        </Link>
      </div>

      <div className="landing-quote">
        <blockquote>
          "What I don't know will always exceed what I know. 
          The goal isn't certainty—it's clarity about the uncertainty."
        </blockquote>
        <p style={{ marginTop: '1rem', fontSize: '0.9rem', color: 'var(--color-text-muted)' }}>
          — Dr. Toye Oyelese
        </p>
      </div>
    </div>
  );
}

export default Landing;
